import { UpdatableForm } from '../../../../components/Purchasing/SupplierRegistration/Form/Member'
import React, { Component, Fragment } from 'react'
import { Col, Divider, Form, Input, Row } from 'antd'
import { strVal } from '../../../../modules/Utils'
import CountrySelect from '../../../../elements/Select/Country'
import CurrencySelect from '../../../../elements/Select/Currency'

class BankAccount extends Component {
  // componentDidMount() {
  //   setTimeout(() => {
  //     if (this.props.bank) {
  //       this.props.lastActionIsNext ? this.props.next() : this.props.prev()
  //     }
  //   }, 50)
  // }

  render() {
    const { getFieldDecorator, setFieldsValue } = this.props.form
    const { supplierRegistration, bank } = this.props

    const formItemLayoutRow = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    return (
      <Fragment>
        <div>
          <Divider orientation="left">Bank Account Details</Divider>
          <Row>
            <Col span={12}>
              <UpdatableForm
                {...{
                  setFieldsValue,
                  getFieldDecorator,
                  label: 'Account Name',
                  path: 'bank.accountName',
                  oldPath: 'bank.accountName',
                  newData: supplierRegistration,
                  newPath: 'bank.accountName',
                  oldData: bank,
                }}
              />
            </Col>
            <Col span={12}>
              <UpdatableForm
                {...{
                  setFieldsValue,
                  getFieldDecorator,
                  label: 'Account Number',
                  path: 'bank.accountNumber',
                  oldPath: 'bank.accountNumber',
                  newData: supplierRegistration,
                  newPath: 'bank.accountNumber',
                  oldData: bank,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <UpdatableForm
                {...{
                  setFieldsValue,
                  getFieldDecorator,
                  label: 'Bank Name',
                  path: 'bank.bankName',
                  oldPath: 'bank.bankName',
                  newData: supplierRegistration,
                  newPath: 'bank.bankName',
                  oldData: bank,
                }}
              />
            </Col>
            <Col span={12}>
              <UpdatableForm
                {...{
                  setFieldsValue,
                  getFieldDecorator,
                  label: 'Branch Name',
                  path: 'bank.branchName',
                  oldPath: 'bank.branchName',
                  newData: supplierRegistration,
                  newPath: 'bank.branchName',
                  oldData: bank,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item label="Country" {...formItemLayoutRow}>
                {getFieldDecorator('bank.country', {
                  initialValue: strVal(supplierRegistration, 'bank.country'),
                  rules: [
                    {
                      required: true,
                      message: "This field can't be empty !",
                    },
                  ],
                })(<CountrySelect />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Currency" {...formItemLayoutRow}>
                {getFieldDecorator('bank.currency', {
                  initialValue: strVal(supplierRegistration, 'bank.currency'),
                  rules: [
                    {
                      required: true,
                      message: "This field can't be empty !",
                    },
                  ],
                })(<CurrencySelect />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <UpdatableForm
                {...{
                  setFieldsValue,
                  getFieldDecorator,
                  label: 'Address',
                  path: 'bank.address',
                  oldPath: 'bank.address',
                  newData: supplierRegistration,
                  newPath: 'bank.address',
                  oldData: bank,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <UpdatableForm
                {...{
                  setFieldsValue,
                  getFieldDecorator,
                  label: 'IBAN',
                  path: 'bank.iban',
                  oldPath: 'bank.iban',
                  newData: supplierRegistration,
                  newPath: 'bank.iban',
                  oldData: bank,
                  required: false,
                }}
              />
            </Col>
            <Col span={12}>
              <UpdatableForm
                {...{
                  setFieldsValue,
                  getFieldDecorator,
                  label: 'Swift Code',
                  path: 'bank.swiftCode',
                  oldPath: 'bank.swiftCode',
                  newData: supplierRegistration,
                  newPath: 'bank.swiftCode',
                  oldData: bank,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <UpdatableForm
                {...{
                  setFieldsValue,
                  getFieldDecorator,
                  label: 'Other Code',
                  path: 'bank.otherCode',
                  oldPath: 'bank.otherCode',
                  newData: supplierRegistration,
                  newPath: 'bank.otherCode',
                  oldData: bank,
                  required: false,
                }}
              />
            </Col>
          </Row>
          <Divider orientation="left">Intermediary Bank Account Details</Divider>
          <Row>
            <Col span={12}>
              <UpdatableForm
                {...{
                  setFieldsValue,
                  getFieldDecorator,
                  label: 'Bank Name',
                  path: 'bank.intermediaryBankDetail.bankName',
                  oldPath: 'bank.intermediaryBankDetail.bankName',
                  newData: supplierRegistration,
                  newPath: 'bank.intermediaryBankDetail.bankName',
                  oldData: bank,
                  required: false,
                }}
              />
            </Col>
            <Col span={12}>
              <UpdatableForm
                {...{
                  setFieldsValue,
                  getFieldDecorator,
                  label: 'Branch Name',
                  path: 'bank.intermediaryBankDetail.branchName',
                  oldPath: 'bank.intermediaryBankDetail.branchName',
                  newData: supplierRegistration,
                  newPath: 'bank.intermediaryBankDetail.branchName',
                  oldData: bank,
                  required: false,
                }}
              />
            </Col>
          </Row>
          <Row>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'Address',
                path: 'bank.intermediaryBankDetail.address',
                oldPath: 'bank.intermediaryBankDetail.address',
                newData: supplierRegistration,
                newPath: 'bank.intermediaryBankDetail.address',
                oldData: bank,
                required: false,
              }}
            />
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item label="Country" {...formItemLayoutRow}>
                {getFieldDecorator('bank.intermediaryBankDetail.country', {
                  initialValue: strVal(supplierRegistration, 'bank.intermediaryBankDetail.country'),
                })(<CountrySelect />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <UpdatableForm
                {...{
                  setFieldsValue,
                  getFieldDecorator,
                  label: 'Swift Code',
                  path: 'bank.intermediaryBankDetail.swiftCode',
                  oldPath: 'bank.intermediaryBankDetail.swiftCode',
                  newData: supplierRegistration,
                  newPath: 'bank.intermediaryBankDetail.swiftCode',
                  oldData: bank,
                  required: false,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <UpdatableForm
                {...{
                  setFieldsValue,
                  getFieldDecorator,
                  label: 'Other Code',
                  path: 'bank.intermediaryBankDetail.otherCode',
                  oldPath: 'bank.intermediaryBankDetail.otherCode',
                  newData: supplierRegistration,
                  newPath: 'bank.intermediaryBankDetail.otherCode',
                  oldData: bank,
                  required: false,
                }}
              />
            </Col>
          </Row>
        </div>
      </Fragment>
    )
  }
}

export default Form.create()(BankAccount)
